import { Routes, Route, Navigate } from 'react-router-dom';
import { getToken } from './api';
import Layout from './components/Layout';
import Login from './pages/Login';
import Download from './pages/Download';
import Dashboard from './pages/Dashboard';
import Departments from './pages/Departments';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Finance from './pages/Finance';
import Products from './pages/Products';
import Sales from './pages/Sales';
import Inventory from './pages/Inventory';
import Production from './pages/Production';
import Customer from './pages/Customer';
import Attendance from './pages/Attendance';
import AttendanceGroups from './pages/AttendanceGroups';
import Logs from './pages/Logs';
import Notifications from './pages/Notifications';
import PortalLogin from './pages/portal/PortalLogin';
import PortalLayout from './pages/portal/PortalLayout';
import PortalHome from './pages/portal/PortalHome';
import PortalOrders from './pages/portal/PortalOrders';
import PortalInventory from './pages/portal/PortalInventory';
import PortalStatements from './pages/portal/PortalStatements';
import PortalNotifications from './pages/portal/PortalNotifications';
import PortalActivate from './pages/portal/PortalActivate';
import PortalBuy from './pages/portal/PortalBuy';

function RequireAuth({ children }: any) {
  if (!getToken()) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      {/* ===== 内部管理系统 ===== */}
      <Route path="/login" element={<Login />} />
      <Route path="/download" element={<Download />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        {/* 业务模块 */}
        <Route path="sales" element={<Sales />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="production" element={<Production />} />
        <Route path="customer" element={<Customer />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="attendance-groups" element={<AttendanceGroups />} />
        {/* 基础数据 */}
        <Route path="products" element={<Products />} />
        <Route path="finance" element={<Finance />} />
        {/* 系统管理 */}
        <Route path="departments" element={<Departments />} />
        <Route path="users" element={<Users />} />
        <Route path="roles" element={<Roles />} />
        <Route path="logs" element={<Logs />} />
        <Route path="notifications" element={<Notifications />} />
      </Route>

      {/* ===== 客户自助报货门户（独立，与内部系统隔离） ===== */}
      <Route path="/portal/login" element={<PortalLogin />} />
      <Route path="/portal/activate" element={<PortalActivate />} />
      <Route path="/portal" element={<PortalLayout />}>
        <Route index element={<PortalHome />} />
        <Route path="buy" element={<PortalBuy />} />
        <Route path="orders" element={<PortalOrders />} />
        <Route path="inventory" element={<PortalInventory />} />
        <Route path="statements" element={<PortalStatements />} />
        <Route path="notifications" element={<PortalNotifications />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
